import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useState, useRef, useEffect } from 'react';
import { tabbingOutsideOfElement } from '@chegg-ui/utils';
import { clickBaseEvent } from '@chegg-me-components/utils';
import { rioClient } from './rio';

function useNavMenuBehavior() {
  var navMenuRef = useRef(null);
  var navHamburgerButtonRef = useRef(null);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      navMenuOpen = _useState2[0],
      setNavMenuOpen = _useState2[1];

  var onNavKeyDown = function onNavKeyDown(e) {
    if (e.key === 'Escape' || e.key === 'Esc') {
      setNavMenuOpen(false);
      /* istanbul ignore else */

      if (navHamburgerButtonRef.current) {
        navHamburgerButtonRef.current.focus();
      }
    } else if (navMenuRef.current && tabbingOutsideOfElement(e, navMenuRef.current)) {
      setNavMenuOpen(false);
    }
  };

  var onNavCloseButtonClick = function onNavCloseButtonClick() {
    setNavMenuOpen(false);
    /**
     * when user clicks on X button to close
     * hamburger menu
     */

    rioClient.sendEvent(_objectSpread(_objectSpread({}, clickBaseEvent), {}, {
      data: {
        interaction: {
          type: 'click',
          element: {
            name: 'nav hamburger closed',
            type: 'button',
            region_name: 'nav hamburger'
          }
        }
      }
    })); // we settimeout to force this to run on the next event loop, after state has updated & button is visible again

    setTimeout(function () {
      /* istanbul ignore else */
      if (navHamburgerButtonRef.current) {
        navHamburgerButtonRef.current.focus();
      }
    }, 0);
  };

  var hideNavOnClickOutside = function hideNavOnClickOutside(e) {
    if (
    /* istanbul ignore next */
    navMenuRef.current && !navMenuRef.current.contains(e.target) &&
    /* istanbul ignore next */
    navHamburgerButtonRef.current) {
      setNavMenuOpen(false);
    }
  };

  useEffect(function () {
    if (navMenuOpen &&
    /* istanbul ignore next */
    navMenuRef.current) {
      var firstLink = navMenuRef.current.querySelector('a');
      /* istanbul ignore else */

      if (firstLink) firstLink.focus(); // use capture instead of bubble here to prevent race condition leading to unintentional closing

      document.addEventListener('click', hideNavOnClickOutside, true);
    }

    return function () {
      document.removeEventListener('click', hideNavOnClickOutside, true);
    };
  }, [navMenuOpen]);
  return {
    navMenuRef: navMenuRef,
    navHamburgerButtonRef: navHamburgerButtonRef,
    navMenuOpen: navMenuOpen,
    setNavMenuOpen: setNavMenuOpen,
    onNavKeyDown: onNavKeyDown,
    onNavCloseButtonClick: onNavCloseButtonClick
  };
}

export default useNavMenuBehavior;